angular.module('callX').controller('SupportStatusCtrl', ['$scope', '$modalInstance', 'statusData', function($scope, $modalInstance, statusData) {
    $scope.statusOptions = [
        'To Do',
        'In Progress',
        'Done',
    ];

    $scope.selectedStatus = statusData;

    console.log($scope.selectedStatus, "existed status value ---------")

    $scope.save = function (selectedStatus) {
        console.log(selectedStatus, "new status value")
        if (selectedStatus) {
            $modalInstance.close(selectedStatus);
        }
    };

    $scope.selectStatus = function(status) {
        $scope.selectedStatus = status;
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

}]);